import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const RESEND_OTP_TIME = 120;

interface Props {
  onResendClick: () => void;
}

export const ResendOtpButton: React.FC<Props> = ({ onResendClick }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(RESEND_OTP_TIME);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsActive(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

  return (
    <Button
      disabled={isActive}
      onClick={() => {
        setTimeLeft(RESEND_OTP_TIME);
        setIsActive(true);
        onResendClick();
      }}
    >
      {isActive ? t("login.resendOtpIn", { time: formattedTime }) : t("login.resendOtp")}
    </Button>
  );
};
